module.exports = __webpack_public_path__ + "img/patch-exclamation-fill.bd6314b3.svg";